import type { AddressType } from "@/pages/search/types";

interface GameUrlType {
  id: string;
  slug?: string;
}

export function gameUrl(game: GameUrlType) {
  return `/attraction/${game.id}${game.slug ? `/${encodeURIComponent(game.slug)}` : ""}`;
}

export function locationName(
  address: AddressType,
  type = "locality",
  isShortName = false
) {
  const found = address.address_components.find(({ types }) =>
    types.includes(type)
  );
  return found ? found[isShortName ? "short_name" : "long_name"] : "";
}

type AddressTypeType = string | [string, boolean];

export function fullLocationName(
  address: AddressType,
  types: AddressTypeType[],
  initial: string[] = []
) {
  const components = types
    .map((type) => {
      const args: [string, boolean?] = typeof type === "string" ? [type] : type;
      return locationName(address, ...args);
    })
    .filter((p) => p !== "");
  return [...initial, ...components].join(", ");
}

interface MinimumLocationType {
  address: AddressType;
  displayName?: string;
}

export function fullLocationDisplayName(location: MinimumLocationType) {
  const country = locationName(location.address, "country", true);

  const initialValue: string[] = [];
  const types: AddressTypeType[] = [];

  if (location.displayName) {
    initialValue.push(location.displayName);
  } else {
    types.push(["neighborhood", true]);
  }

  if (country === "US") {
    types.push("locality");
    types.push(["administrative_area_level_1", true]);
  } else {
    types.push("administrative_area_level_2");
    types.push("country");
  }

  return fullLocationName(location.address, types, initialValue);
}

export function cityStateDisplayName(location: MinimumLocationType) {
  const country = locationName(location.address, "country", true);

  const types: AddressTypeType[] = [];

  if (country === "US") {
    types.push("locality");
    types.push(["administrative_area_level_1", true]);
  } else {
    types.push("locality");
    types.push("country");
  }

  return fullLocationName(location.address, types);
}
